import React, { useEffect, useState } from "react";
import Slider from "react-slick";
import headerLogo from "../../../assets/images/logo-preview.png";

import { BiUser } from "react-icons/bi";
import { GoGear, GoGraph, GoMail } from "react-icons/go";
import { MdNotificationsNone } from "react-icons/md";
import { FaChromecast } from "react-icons/fa";
import { CiSearch } from "react-icons/ci";
import { Tabs, Tab, Box } from "@mui/material";
import AppBar from "@mui/material/AppBar";
import { RiDeleteBin5Line } from "react-icons/ri";
import { IoAirplaneOutline, IoNewspaperOutline } from "react-icons/io5";
import './CdsnRailPreview.scss';

function a11yProps(index) {
    return {
        id: `full-width-tab-${index}`,
        "aria-controls": `full-width-tabpanel-${index}`,
        className: `eachtab`,
    };
}


const RailConfigPreview = (props) => {
    const { previewListRowData, welcomeMsgConfigList, setPreview, fetchCDSNHotelConfigList } = props
    const [currentSlide, setCurrentSlide] = useState(0);
    const [buttonHref, setButtonHref] = useState('#');
    const [buttonText, setButtonText] = useState('Watch Now');

    const boxStyle = {
        position: "absolute",
        backgroundColor: '#000000',
        zIndex: "1",
        height: "3vh",
        width: "100%",
        boxShadow: "0 13px 23px #000",
    };

    const boxStyle2 = {
        position: "absolute",
        backgroundColor: '#000000',
        zIndex: "1",
        height: "65vh",
        width: "27%",
        boxShadow: "140px 0px 94px #000",
    };

    const settings = {
        dots: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        initialSlide: 0,
        arrows: false,
        autoplay: true,
        autoplaySpeed: 5000,
        afterChange: (index) => setCurrentSlide(index),
    };

    const HotelServiceSettings = {
        dots: false,
        arrows: false,
        speed: 500,
        slidesToShow: 5,
        draggable: false,
        swipe: false,
        infinite: false
    };

    const railsSettings = {
        dots: false,
        arrows: false,
        speed: 500,
        slidesToShow: 9,
        draggable: false,
        swipe: false,
        infinite: false
    };

    const channelsSettings = {
        dots: false,
        speed: 500,
        slidesToShow: 9,
        arrows: false,
        draggable: false,
        swipe: false,
        infinite: false
    };

    useEffect(() => {
        const img = previewListRowData.bannerResponse[currentSlide];
        // if (img.selectionType === "CUSTOM_BANNER") {
        //     setButtonHref('#');
        //     setButtonText(img?.ctaText || 'Watch Now');
        //     return;
        // }

        let href = '#';
        if (img.selectionType === 'IMAGE') {
            href = img.imageUrl;
        } else if (img.selectionType === 'WEB_LINK') {
            href = img.webLink;
        } else if (img.selectionType === "YOUTUBE_LINK") {
            href = img.youtubeLink;
        }

        setButtonHref(href);
        setButtonText(img.ctaText || 'Watch Now');
    }, [currentSlide, previewListRowData]);

    return (
        <div className="cdsn-details-preview-popup">
            <p className="popup-close" onClick={() => setPreview(false)}>X</p>
            <div className="cdsn-details-preview">
                {Array.isArray(previewListRowData?.bannerResponse) &&
                    previewListRowData.bannerResponse.length > 0 &&
                    previewListRowData.bannerResponse?.length > 0 && (
                        <div className="preview-img">
                            <div style={boxStyle}></div>
                            <div style={boxStyle2}></div>
                            {previewListRowData.bannerResponse.length > 1 ? (
                                <Slider {...settings}>
                                    {previewListRowData.bannerResponse.map((img, index) => (
                                        <img key={index} src={img?.bannerImages} alt={`Banner ${index}`} className="banner" />
                                    ))}
                                </Slider>
                            ) : (
                                <img
                                    src={previewListRowData.bannerResponse[0].bannerImages}
                                    alt="Banner"
                                    className="banner"
                                />
                            )}
                            <div className="preview-header ps-3">
                                <div className="header">
                                    <div className="logos">
                                        <img src={headerLogo} alt="header logo" className="main-logo" />
                                        {fetchCDSNHotelConfigList?.logoUrl !== null && <div><img src={fetchCDSNHotelConfigList?.logoUrl} alt='hotel-logo' className="hotel-logo" /></div>}
                                    </div>
                                    <div className="header-icons">
                                        {/* <FontAwesomeIcon icon={faUser} className="" /> */}
                                        <CiSearch />
                                        <MdNotificationsNone />
                                        <GoMail />
                                        <GoGear />
                                        <BiUser />
                                    </div>
                                </div>
                                <Box className="cdsn-boxroot mt-3">
                                    <AppBar position="static">
                                        <Tabs
                                            // variant="scrollable"
                                            TabIndicatorProps={{
                                                hidden: true,
                                                style: { transition: "none" },
                                            }}
                                        >
                                            <Tab label="Home" {...a11yProps(0)} className="Mui-selected eachtab" />
                                            <Tab label="Tv Channels" {...a11yProps(1)} />
                                            <Tab label="Binge" {...a11yProps(2)} />
                                            <Tab label="Apps" {...a11yProps(3)} />
                                        </Tabs>
                                    </AppBar>
                                </Box>
                                <div className="preview-welcome-msg">
                                    <p className="py-4">{welcomeMsgConfigList?.welcomeMessage}</p>
                                    {/* {previewListRowData.bannerResponse.length > 1 ? (
                                        <Slider {...{ ...settings, dots: false }}>
                                            {previewListRowData.bannerResponse.map((img) => (
                                                img?.selectionType!== null ? <a href={img?.selectionType === "IMAGE" ? img?.imageUrl : img?.selectionType === "WEB_LINK" || img?.selectionType === "YOUTUBE_LINK" ? img?.linkUrl : img?.linkUrl} target="_blank" >
                                                    {img?.ctaText ? img?.ctaText : 'Watch Now'}</a> : <a href="#">{img?.ctaText ? img?.ctaText : 'Watch Now'}</a>
                                        ))}
                                        </Slider>
                                    ) : (
                                        <button type="button">Watch Now</button>
                                    )} */}
                                    {previewListRowData.bannerResponse[currentSlide].selectionType !== "CUSTOM_BANNER" ? <a href={buttonHref} target="_blank" rel="noopener noreferrer">
                                        {buttonText}
                                    </a> : <a rel="noopener noreferrer">{buttonText}</a> }

                                </div>
                            </div>
                        </div>
                    )}
                <div className="preview-body">
                     {previewListRowData?.utilityResponse !==null &&<div className="cost-devices">
                        <div>
                            <FaChromecast />
                            <p>Cast Your Device</p>
                        </div>
                        <div>
                            <RiDeleteBin5Line />
                            <p>Clear App Credentials</p>
                        </div>
                        <div>
                            <IoNewspaperOutline />
                            <p>News Updates</p>
                        </div>
                        <div>
                            <IoAirplaneOutline />
                            <p>Flight Status</p>
                        </div>
                        <div>
                            <GoGraph />
                            <p>Market Updates</p>
                        </div>
                    </div> }
                    {previewListRowData?.partnerApps?.length > 0 && <div className="partner-rails">
                        <p>OTT Apps</p>
                        <Slider {
                            ...{
                                ...railsSettings,
                                arrows: previewListRowData?.partnerApps?.length > 9,
                            }
                        }
                            className="mx-4"
                        >
                            {previewListRowData?.partnerApps?.map((list, index) =>
                                <img src={list?.logoUrl} alt={index} className="ott-apps" />
                            )}
                        </Slider>

                    </div>}
                    {/* {previewListRowData?.tataSkyChannelResponse?.length > 0 && <div className="partner-rails">
                    <p>Tata play Linear Channels</p>
                    < Slider {
                        ...{
                            ...channelsSettings,
                            arrows: previewListRowData?.tataSkyChannelResponse?.length > 9,
                        }
                    }
                        className="mx-4"
                    >
                        {previewListRowData?.tataSkyChannelResponse?.map((list, index) =>
                            <img src={list?.thumbnailImage} alt={index} />
                        )}
                    </Slider>

                </div>} */}
                    {previewListRowData?.tataSkyChannelResponse?.length > 0 &&
                        <div className="partner-rails">
                            <p>Tata play Linear Channels</p>
                            {previewListRowData?.tataSkyChannelResponse?.map((channelConfig) =>
                                <div className="channel-categories">
                                    <h6>{channelConfig?.categoryName}</h6>
                                    <Slider   {...{
                                        ...channelsSettings,
                                        arrows: channelConfig?.channels?.length > 9,
                                    }}
                                        className="mx-4"
                                    >
                                        {channelConfig?.channels?.map((list, index) =>
                                            <img src={list?.thumbnailImage} alt={index} />
                                        )}
                                    </Slider>
                                </div>
                            )}
                        </div>
                    }
                    {previewListRowData?.hotelServiceResponse?.length > 0 && <div className="partner-rails mt-2">
                        <p>Hotel Services</p>
                        < Slider {
                            ...{
                                ...HotelServiceSettings,
                                arrows: previewListRowData?.hotelServiceResponse?.length > 5,
                            }
                        }
                            className="mx-4"
                        >
                            {previewListRowData?.hotelServiceResponse?.map((list, index) =>
                                <div className="hotel-rails-img">
                                    <div className="position-relative">
                                        <img src={list?.menuImageUrl} alt={index} />
                                        <p className="hotel-service-title">{list?.menuName}</p>
                                    </div>
                                </div>
                            )}
                        </Slider>

                    </div>
                    }
                    {previewListRowData?.hotelChannelResponse?.length > 0 && <div className="partner-rails mt-2">
                        <p>Hotel Channels</p>
                        < Slider {
                            ...{
                                ...channelsSettings,
                                arrows: previewListRowData?.hotelChannelResponse?.length > 5,
                            }
                        }
                            className="mx-4"
                        >
                            {previewListRowData?.hotelChannelResponse?.map((list) =>
                                <div>
                                    <img src={list?.channelLogo} alt={list?.channelName} />
                                    {/* <p>{list?.channelName}</p> */}
                                </div>
                            )}
                        </Slider>

                    </div>
                    }
                    {/* {previewListRowData?.utilityResponse?.length > 0 && <div className="partner-rails">
                        <p>Utilities</p>
                        < Slider {
                            ...{
                                ...railsSettings,
                                arrows: previewListRowData?.utilityResponse?.length > 9,
                            }
                        }
                            className="mx-4"
                        >
                            {previewListRowData?.utilityResponse?.map((list, index) =>
                                <img src={list?.thumbnailUrl} alt={index} />
                            )}
                        </Slider>

                    </div>} */}
                </div>

            </div>
        </div>
    )
}

export default RailConfigPreview;